import { useState } from 'react';
import { Switch } from '@mui/material';
import toast from 'react-hot-toast';
import { LivestreamingModal } from './LivestreamingModal';
import { useSetLivestreamingMutation } from '../../../../generated/graphql';
import { useInfluencer } from '@client/new/hooks/use-influencer';

export const LivestreamingToggle = ({
  influencerId,
  isEnabledLivestreaming,
}: {
  influencerId: number;
  isEnabledLivestreaming: boolean;
}) => {
  const [isEnabled, setEnabled] = useState(isEnabledLivestreaming);
  const [openModal, setOpenModal] = useState(false);
  const [isSubmitting, setSubmitting] = useState(false);
  const { refetchInfluencer } = useInfluencer({
    creatorId: influencerId,
  });

  const [setLivestreamingMutation] = useSetLivestreamingMutation();
  const onSubmit = async () => {
    setSubmitting(true);
    return await setLivestreamingMutation({
      variables: {
        data: {
          influencerId,
          isEnabled: !isEnabled,
        },
      },
    })
      .then(() => {
        refetchInfluencer();
        toast.success(
          isEnabled
            ? 'Livestreaming has been successfully disabled.'
            : 'Livestreaming is now available!',
        );
        setEnabled((prev) => !prev);
      })
      .catch(() => {
        toast.error('Something went wrong!');
      })
      .finally(() => {
        setOpenModal(false);
        setSubmitting(false);
      });
  };

  return (
    <>
      <Switch checked={isEnabled} onChange={() => setOpenModal(true)} />
      <LivestreamingModal
        open={openModal}
        toggle={() => setOpenModal((prev) => !prev)}
        onSubmit={onSubmit}
        isEnabled={isEnabled}
        isSubmitting={isSubmitting}
      />
    </>
  );
};
